'use strict';

import 'moment/locale/ru';

function Article (object) {
  this.id = object.get('id');
  this.uri = object.get('path');
  this.title = object.get('title');
  this.mainPhoto = object.get('image');
}

const proto = Article.prototype;

proto.getId = function () {
  return this.id;
};

proto.getTitle = function () {
  return this.title;
};

proto.getUri = function () {
  return this.uri;
};

proto.getMainPhoto = function () {
  return this.mainPhoto;
};

export default Article;



// WEBPACK FOOTER //
// ./src/classes/common/article.js